import Link from "next/link";

export const FOOTER_CONSTANTS = {
  btnText: "Ready To Buy?",
  text1: (
    <>
      We have more servers for your business. Check our{" "}
      <Link
        href="/pricing?table=baremetal"
        style={{ textDecoration: "underline", color: "#1E87F0", fontWeight: 700 }}
      >
        Pricing Catalog
      </Link>{" "}
      for more information.
    </>
  ),
};
